import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const VariantBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing.plusHalf};
`;
